import React from 'react';
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button } from '@heroui/react';
import { Icon } from '@iconify/react';
import { RefShareOrder, OrderStatus } from '../../../../api/services';

interface CampaignActionsCellProps {
  order: RefShareOrder;
  onStatusChange?: (orderId: string, status: OrderStatus) => void;
}

interface StatusOption {
  key: OrderStatus;
  label: string;
  icon: string;
  iconColor: string;
}

const STATUS_OPTIONS: StatusOption[] = [
  { key: 'in_progress', label: 'Активировать', icon: 'solar:play-circle-linear', iconColor: '#17c964' },
  { key: 'in_moderation', label: 'На модерацию', icon: 'solar:eye-linear', iconColor: '#7828C8' },
  { key: 'canceled', label: 'Отменить', icon: 'solar:close-circle-linear', iconColor: '#F31260' },
];

const CampaignActionsCell: React.FC<CampaignActionsCellProps> = ({ order, onStatusChange }) => {
  const orderId = order._id || order.id || '';
  const currentStatus = order.status;

  // Get available status options (all statuses except current)
  const availableStatuses = STATUS_OPTIONS.filter(option => option.key !== currentStatus);

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button
          variant="light"
          isIconOnly
          className="min-w-[32px] w-[32px] h-[32px]"
        >
          <Icon icon="solar:menu-dots-bold" width={20} height={20} />
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Сменить статус"
        onAction={(key: React.Key) => {
          const newStatus = key as OrderStatus;
          onStatusChange?.(orderId, newStatus);
        }}
      >
        {availableStatuses.map((option) => (
          <DropdownItem key={option.key}>
            <div className="flex items-center gap-[8px]">
              <Icon icon={option.icon} fontSize={16} style={{ color: option.iconColor }} />
              <span>{option.label}</span>
            </div>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CampaignActionsCell;
